export enum FirebaseDB {
  ACTIVE_STATE = "state",
}

export type IconState = {
  icon: string;
  state: number;
};
